/**
 * Escala tipográfica calibrada para DENSIDADE, não para marketing.
 *
 * Base 14 e não 16: a tela desta ferramenta é fila e tabela, e o público
 * veio do Excel. Não existe tamanho de display aqui de propósito — a maior
 * coisa na tela é um h1 de 22px, porque acima disso a linha de tabela perde
 * a hierarquia contra o título.
 *
 * As duas famílias são SELF-HOSTED via @fontsource (veja `fontes.ts`).
 * Nunca CDN do Google: é ferramenta interna com dado de saúde, e um <link>
 * para fonts.gstatic.com vaza padrão de uso para terceiro.
 */

/** UI. O fallback termina em Arial — existe em toda máquina Windows do time. */
export const familiaDeInterface = [
  '"Plus Jakarta Sans"',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(', ');

/**
 * Identificadores: correlation_id, protocolo, código do ticket, carteirinha.
 * Monoespaçada porque esses valores são COMPARADOS visualmente e copiados,
 * não lidos como prosa.
 */
export const familiaDeIdentificador = [
  '"Space Mono"',
  'ui-monospace',
  'SFMono-Regular',
  '"Cascadia Mono"',
  'Consolas',
  '"Liberation Mono"',
  'monospace',
].join(', ');

export const pesos = {
  normal: 400,
  medio: 500,
  forte: 600,
  destaque: 700,
} as const;

/** Onde houver número, `tabular-nums`: coluna de valor tem que alinhar. */
export const numerosTabulares = { fontVariantNumeric: 'tabular-nums' } as const;

/** Tamanho base em px. O MUI converte o resto da escala a partir daqui. */
export const tamanhoBase = 14;

/** Célula de tabela: 13px em 1.25 de entrelinha. É a densidade do Excel. */
export const celulaDeTabela = {
  fontSize: '0.8125rem',
  lineHeight: 1.25,
} as const;
